import { z } from 'zod';
// Mobil/web tarafindan: ödeme intent olustur
export const odemeIntentIstegi = z.object({
    amac: z.enum(['KIRALAMA', 'CUZDAN_YUKLE']),
    tutar: z.number().positive().max(100000), // TL
    paraBirimi: z.enum(['TRY', 'EUR', 'USD']).default('TRY'),
    // KIRALAMA amaci icin zorunlu
    kiralamaId: z.string().optional(),
    // UI'ya gosterilecek aciklama
    aciklama: z.string().min(1).max(200),
});
export const odemeIntentCevabi = z.object({
    token: z.string(),
    // Tarayıcı bu URL'i acar — text/html donen Akbank gateway form'u var
    formUrl: z.string().url(),
    // Bittikten sonra sonuc icin polling URL
    durumUrl: z.string().url(),
    sonKullanmaSn: z.number().int(),
});
export const odemeDurumCevabi = z.object({
    token: z.string(),
    durum: z.enum(['BEKLEMEDE', 'ISLENIYOR', 'BASARILI', 'BASARISIZ', 'IPTAL', 'SURESI_DOLDU']),
    amac: z.enum(['KIRALAMA', 'CUZDAN_YUKLE']),
    tutar: z.string(), // Decimal stringified
    paraBirimi: z.enum(['TRY', 'EUR', 'USD']),
    saglayici: z.string(), // AKBANK
    bankaIslemId: z.string().nullable(),
    hataMesaji: z.string().nullable(),
    olusturmaTarihi: z.string(),
});
// Admin Akbank test endpoint
export const akbankTestCevabi = z.object({
    basarili: z.boolean(),
    hata: z.string().optional(),
    saglayiciHataKodu: z.union([z.string(), z.number()]).optional(),
});
//# sourceMappingURL=intent.js.map